/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { create } from '../fn/audit-form-risk-entry/create';
import { Create$Params } from '../fn/audit-form-risk-entry/create';
import { deleteEntry } from '../fn/audit-form-risk-entry/delete-entry';
import { DeleteEntry$Params } from '../fn/audit-form-risk-entry/delete-entry';
import { FormRiskEntry } from '../models/form-risk-entry';
import { update } from '../fn/audit-form-risk-entry/update';
import { Update$Params } from '../fn/audit-form-risk-entry/update';

@Injectable({ providedIn: 'root' })
export class AuditFormRiskEntryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `auditFormRiskEntryControllerUpdate()` */
  static readonly AuditFormRiskEntryControllerUpdatePath = '/auditing/forms/{formId}/risk-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `update()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update$Response(params: Update$Params, context?: HttpContext): Observable<StrictHttpResponse<FormRiskEntry>> {
    return update(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `update$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  update(params: Update$Params, context?: HttpContext): Observable<FormRiskEntry> {
    return this.update$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormRiskEntry>): FormRiskEntry => r.body)
    );
  }

  /** Path part for operation `auditFormRiskEntryControllerCreate()` */
  static readonly AuditFormRiskEntryControllerCreatePath = '/auditing/forms/{formId}/risk-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: Create$Params, context?: HttpContext): Observable<StrictHttpResponse<FormRiskEntry>> {
    return create(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: Create$Params, context?: HttpContext): Observable<FormRiskEntry> {
    return this.create$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormRiskEntry>): FormRiskEntry => r.body)
    );
  }

  /** Path part for operation `auditFormRiskEntryControllerDeleteEntry()` */
  static readonly AuditFormRiskEntryControllerDeleteEntryPath = '/auditing/forms/{formId}/risk-entry/{formRiskEntryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEntry()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEntry$Response(params: DeleteEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEntry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEntry(params: DeleteEntry$Params, context?: HttpContext): Observable<void> {
    return this.deleteEntry$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
